<template>
  <canvas id="project-chart" />
</template>

<script>
import Chart from 'chart.js';
export default {
  props: ["chartData", "options"],
  mounted () {
    let chart = document.getElementById("project-chart")
    this.myChart = new Chart(chart, {
          type: 'doughnut',
          data: this.chartData,
          options: {
            legend: {
              display: false
            },
          },
          responsive: true,
          maintainAspectRatio: false
        });
    
  }
}
</script>
<style scoped>
#project-chart{
  height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/People/ProjectChart.vue